function Home() {
    return (
        <section className='content-wrapper'>
            <h1>환영합니다!</h1>
            <hr></hr>
            <p>
                카라쿤의 퍼즐 월드에 오신 것을 환영합니다!
            </p>
        </section>
    );
}

export default Home;